export default "__VITE_ASSET__6c303e0b__"